import { fetchAll } from '@/api/vehicletypes'

const state = {
  all: [],
  isLoading: false
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const vehicletypes = await fetchAll(payload)
      commit('setAll', vehicletypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
  },

  setAll (state, vehicletypes) {
    state.all = vehicletypes
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
